// ImageList.js
import React from 'react';

function ImageList() {
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-4">
          <img src="/images/Image1.jpg" className="img-fluid" alt="..." />
        </div>
        <div className="col-md-4">
          <img src="/images/Image2.jpg" className="img-fluid" alt="..." />
        </div>
        <div className="col-md-4">
          <img src="/images/Image3.jpg" className="img-fluid" alt="..." />
        </div>
      </div>
      {/* Add more images here */}
    </div>
  );
}

export default ImageList;
